import Spacer from "@components/Spacer";
import ClockIcon2 from "@components/icons/clock-icon-2";
import PersonsIcon from "@components/icons/persons-icon";
import type { Recipe } from "@type/recipe";
import { Text, View } from "dripsy";
import * as React from "react";

function RecipeDetailView({ recipe, isSmall }: { recipe: Recipe | undefined; isSmall?: boolean }) {
  return (
    <View
      sx={{
        zIndex: 100,
        display: "flex",
        flexDirection: "row",
      }}
    >
      <View sx={{ display: "flex", flexDirection: "row" }}>
        <PersonsIcon size={isSmall ? 14 : 16} color="$background" />
        <Text sx={{ fontSize: isSmall ? 14 : 16, fontWeight: "600", color: "$background", marginLeft: "$1" }}>
          {recipe
            ? isSmall
              ? recipe?.person_amount
              : recipe?.person_amount === 1
              ? `${recipe?.person_amount} persoon`
              : `${recipe?.person_amount} personen`
            : "..."}
        </Text>
      </View>
      <Spacer horizontal />
      <View sx={{ display: "flex", flexDirection: "row" }}>
        <ClockIcon2 size={isSmall ? 14 : 16} color="$background" />
        <Text sx={{ fontSize: isSmall ? 14 : 16, fontWeight: "600", color: "$background", marginLeft: "$1" }}>
          {recipe ? recipe?.cooking_time : "..."}
        </Text>
      </View>
    </View>
  );
}

export default RecipeDetailView;
